import React from 'react'
import { Link } from 'react-router-dom';

function Futuroexpo() {
    const images = [
        {
          src: "images/daisypre.jpg",
          title: "Modern Design",
          description: "Available in 91 or 100 cm wide and 120 or 135 cm high models.",
        },
        {
          src: "images/daisypre1.jpg",
          title: "Refrigerated Storage",
          description: "Models with refrigerated understorage and independent temperature control for quick product replenishment.",
        },
        {
          src: "images/daisypre2.jpg",
          title: "Easy Access",
          description: "Front glass with gas strut for easy access and cleaning of the display unit.",
        },
      ];
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/islands" className="block py-1 pl-4 hover:underline mt-6">Islands -</Link>
           <span className="block py-1 pl-4 mt-6">FUTURO EXPO</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/futuroexponew.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">FUTURO EXPO</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">The panoramic merchandiser which stimulates impulse buying</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">FUTURO EXPO is a plug-in merchandiser for packed products, such as Meat, Charcuterie, Fruit & Vegetables, Drinks, Dairy Products and Pastry. Ideal for sales actions, quickly and effectively exposes your products wherever convenient</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">

       <p className="text-xl lg:text-2xl opacity-90">PACKED MEAT<span className=' text-blue-400'> -1… +5 °C</span>(3M1)</p>
       <p className="text-xl lg:text-2xl opacity-90">OTHER PACKED FOODS<span className=' text-blue-400'> -1… +7 °C</span>(3M2)</p>

    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
         
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">R290</p>

         </div>

 {/* case 3 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                  {/* ✅ Image Wrapper */}
  <div className="w-full md:w-1/2">
                 <img src="/images/futurogif.gif" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">The merchandiser that highlights, even more, your campaigns and sales!</p>
    <ul className="list-[square] list-outside text-gray-500">
  {[
    "Fan assisted cooling with uniform temperature distribution.",
    "360º panoramic display for maximum visibility of your products.",
    "Plug-in solution, just plug it into the socket.",
    "With casters for easy in-store movement.",
    "Available as painted or stainless steel finishing.",
    "Easy removable and cleanable internal components."
  ].map((item, index) => (
    <li key={index} className="md:text-xl font-thin opacity-90 mt-6">
      {item}
    </li>
  ))}
</ul>

</div>

             </div>
     </div>
    
  
        </div>
      )
    }

export default Futuroexpo